import React from 'react';

type PageHeadingProps = {
  heading: string;
  headingLevel?: 'h1' | 'h2' | 'h3';
  children?: React.ReactNode;
  extraContent?: React.ReactNode;
  withBorder?: boolean;
  className?: string;
};

const PageHeading: React.FC<PageHeadingProps> = ({
  heading,
  headingLevel = 'h1',
  children,
  extraContent,
  withBorder = false,
  className = ''
}) => {
  const Heading = headingLevel;
  const rowClassName = [
    'flex items-center justify-between',
    withBorder ? 'border-b border-zinc-200 pb-2 mb-4' : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rowClassName}>
      <div className="flex-1">
        <Heading className={withBorder ? 'page-heading mb-1' : 'page-heading'}>{heading}</Heading>
        {extraContent}
      </div>
      {children && <div className="flex flex-row items-center justify-end gap-3">{children}</div>}
    </div>
  );
};

export default PageHeading;
